<template>
    <div class="mt-12">
        <v-row>
            <v-col cols="12" sm="8" md="8">
                <h1 class="font-weight-bold" style="font-size: 20px;line-height: 23px;">Resultados da consulta</h1>
                <h3 style="font-style: normal;font-weight: 300;font-size: 16px;line-height: 20px;">Você pode alterar o período da consulta com os filtros avançados.</h3>
            </v-col>
            <v-spacer />
          <v-col cols="12" sm="4" md="4" align-self="start" align="start" v-if="this.$vuetify.breakpoint.name === 'xs'">
            <div class="mr-2" @click="filter = !filter" style="cursor: pointer;">
              <v-icon color="secondary lighten-1" left>mdi-filter-outline</v-icon>
              <span class="secondary--text text--lighten-1">Filtrar para outros períodos</span>
            </div>
          </v-col>
          <v-col cols="12" sm="4" md="4" align-self="end" align="end" v-else>
            <div class="mr-2" @click="filter = !filter" style="cursor: pointer;">
              <v-icon color="secondary lighten-1" left>mdi-filter-outline</v-icon>
              <span class="secondary--text text--lighten-1">Filtrar para outros períodos</span>
            </div>
          </v-col>
        </v-row>
        <search-other-period-date
            v-if="getType && filter && !loadingData"
            :type="getType"
            @applyPeriod="applyPeriod($event)"
        >
        </search-other-period-date>

        <v-card v-if="showAnimation" class="mt-3 primary darken-1">
            <div style="height: 300px;">
                <loading-animation
                    @loopComplete="loadAnimationComplete"
                ></loading-animation>
            </div>
        </v-card>

        <div v-else>
            <cards-data-search-result
                v-if="searchResult && searchResult.type !== 'observado'"
                :searchResult="searchResult"
                @highlightsCards="highlightsCards=$event"
            ></cards-data-search-result>
            <v-card color="mt-3 pa-2 primary darken-1" min-height="600">
                <h3 class="ml-4 mt-4" v-if="dataPeriodDate" style="color: #A0A0A0;font-weight: normal;font-size: 12px;line-height: 16px;">
                    <v-icon color="#A0A0A0" small>mdi-calendar-month-outline</v-icon>
                    Visualizando dados de {{formatDate(dataPeriodDate[0])}} a {{formatDate(dataPeriodDate[1])}}
                </h3>
                <v-card-title class="mb-0">
                    <chart-header
                        :authorize="authorize"
                        :isTable="isTableTab"
                        @fullscreenChart="fullscreenChart"
                        @printChart="printChart"
                        @exportChart="exportChart($event)"
                        @exportPDF="exportPDF"
                        @exportCSV="exportCSV"
                        @exportXLS="exportXLS"
                    >
                        <template v-slot:title v-if="searchResult">
                            {{searchResult.station.nome}}
                        </template>
                    </chart-header>
                </v-card-title>

                <v-card-text >
                    <h3 class="subtitle-1 white--text">Selecione o tipo da visualização:</h3>
                    <v-tabs class="hidden-sm-and-down secondary--text text--lighten-1" v-model="tab" active-class="secondary lighten-1 primary--text text--darken-1" background-color="primary darken-1" slider-color="secondary lighten-1">
                        <v-tab class="tab-item-title" v-for="(item, index) in items" :key="index" :id="item.id">{{item.title}}</v-tab>
                    </v-tabs>

                    <v-menu
                        bottom
                        left
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn

                            class="hidden-md-and-up tab-item-title tranparent"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            >
                            {{items[tab].title}}
                            <v-icon >
                                mdi-menu-down
                            </v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item v-for="(item, index) in items" :key="index" @click="changeTabItem(index)">
                            {{item.title}}
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-tabs-items v-model="tab" class="primary darken-1" touchless>
                        <v-tab-item
                            class="px-0"
                        >
                            <v-card flat color="primary darken-1">
                                <v-card-text v-if="alert">
                                <br/>
                                <v-icon class="mr-2" color="warning">mdi-alert-circle-outline</v-icon>
                                <span class="warning--text">Não há resultados no período pesquisado.</span>
                                </v-card-text>
                                <v-card-text v-show="!alert && !showAnimation">
                                <station-sensors-chart
                                    :series="series"
                                    :types="types"
                                    :searchResult="searchResult"
                                    @chartRenderComplete="chartRenderComplete($event)"
                                ></station-sensors-chart>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card v-if="searchResult" class="px-6" flat color="primary darken-1">
                                <daily-monthly-table-data
                                    v-if="getType === 'mensal' || getType === 'diario' && highlightsCards"
                                    :ref="this.dailyMonthlyTableDataRef"
                                    :searchResult="processResultForTable(searchResult)"
                                    :highlightsCards="highlightsCards"
                                >
                                </daily-monthly-table-data>
                                <hourly-table-data
                                    v-if="getType === 'horario' && highlightsCards"
                                    :ref="this.hourlyTableDataRef"
                                    :searchResult="processResultForTable(searchResult)"
                                    :highlightsCards="highlightsCards"
                                    :dataPeriodDate="dataPeriodDate"
                                >
                                </hourly-table-data>
                                <observed-table-data
                                    v-if="getType === 'observado'"
                                    :ref="this.observedTableDataRef"
                                    :searchResult="processResultForTable(searchResult)"
                                    :dataPeriodDate="dataPeriodDate"
                                >
                                </observed-table-data>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </div>

        <settings-export-dialog
            ref="settingsExportDialog"
            @exportData="exportDataTable($event)"
        >
        </settings-export-dialog>
    </div>
</template>

<script>
import moment from "moment";
import ChartHeader from "../common/ChartHeader.vue";
import { chartStationsData, tableStationsData } from '../../helpers/chart_export_authorization';
import SearchOtherPeriodDate from './SearchOtherPeriodDate';
import CardsDataSearchResult from "./CardsDataSearchResult";
import LoadingAnimation from "../common/LoadingAnimation.vue"
import DailyMonthlyTableData from "./TableData/DailyMonthlyTable/DailyMonthlyTableData.vue";
import HourlyTableData from './TableData/HourlyTable/HourlyTableData.vue';
import ObservedTableData from "./TableData/ObservedTable/ObservedTableData.vue";
import SettingsExportDialog from './SettingsExportDialog.vue';
import StationSensorsChart from "./StationSensorsChart";
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/exporting'
Exporting(Highcharts)
export default {
    name: "SearchResult",
    props: {
        searchResult:{
            type: Object
        },
        type:{
            type: String,
        },
        loadingOtherPeriod: {
            type: Boolean,
            default: false,
        },
        loadingData: {
            type: Boolean,
            default: false,
        },
        types:{
            type: Array
        }
    },
    components:{
        StationSensorsChart,
        CardsDataSearchResult,
        ChartHeader,
        SearchOtherPeriodDate,
        LoadingAnimation,
        DailyMonthlyTableData,
        HourlyTableData,
        ObservedTableData,
        SettingsExportDialog
    },
    data: () => ({
        tab: undefined,
        items:[
            {
                title: 'Gráfico',
                id: 'tab-charts'
            },
            {
                title: 'Tabela',
                id: 'tab-table'
            },
        ],
        authorize: [],
        filter: undefined,
        showAnimation: false,
        highlightsCards: undefined,
        otherPeriodSelected: undefined,
        dailyMonthlyTableDataRef: "dailyMonthlyTableData",
        hourlyTableDataRef: "hourlyTableData",
        observedTableDataRef: "observedTableData",
        chartRendered: undefined,
        animationShow: false,
        loading: false,
        alert: false,
        series: [],
    }),

    created(){
        this.authorize = chartStationsData;
        this.tab = 0;
        if(this.searchResult){
            if(this.searchResult.resultList.length > 0){
                this.precessChart()
                this.alert = false
            } else {
                this.alert = true
            }
        }
    },

    watch:{
        tab(value){
            if(value === 0){
                this.authorize = chartStationsData;
            }else if(value === 1){
                this.authorize = tableStationsData;
            }
        },
        searchResult() {
            if(this.searchResult){
                if(this.searchResult.resultList.length > 0){
                    this.precessChart()
                    this.alert = false
                } else {
                    this.alert = true
                }
            }
        },
        loadingOtherPeriod(value){
            if(value){
                this.showAnimation = this.loadingOtherPeriod;
            }
        },
        loadingData(value){
            if(value){
                this.showAnimation = this.loadingData;
                this.otherPeriodSelected= undefined;
            }
        },
    },

    computed:{
        getType(){
            return this.type ? this.type : this.searchResult.type;
        },
        sensors(){
            return this.$store.getters.sensors
        },
        dataPeriodDate(){
            //if(this.otherPeriodSelected) return this.otherPeriodSelected.period;
            if(!this.searchResult) return undefined;
            const { date_start, date_end } = this.searchResult;
            return date_start && date_end ? [date_start, date_end] : undefined;
        },
        isTableTab(){
            return this.tab === 1;
        }
    },

    methods:{
        async precessChart(){
            let beforeReduce = []
            if(this.searchResult.type === 'observado'){
                beforeReduce = this.searchResult.resultList.filter((a) => a.qualidadeId === '0')
            } else { beforeReduce = this.searchResult.resultList }
            let reduced = beforeReduce.reduce((objetoFinal, objetoAtual) => {
                if (!objetoFinal[objetoAtual.sensorId]) objetoFinal[objetoAtual.sensorId] = []
                objetoFinal[objetoAtual.sensorId].push(objetoAtual);
                return objetoFinal
            }, {})
            let series = []
            for (let index in reduced){
                let serie =  await this.processChart(index, reduced[index])
                series.push(serie)
            }
            //colors
            if(series){
                let line = series.filter((a) => a.type === 'line')
                let column = series.filter((a) => a.type === 'column')
                if(series.length === 2){
                if(line.length === 2){
                    series[0].color = '#95A1EC'
                    series[1].color = '#008AD7'
                } else if(column.length === 2){
                    series[0].color = '#95A1EC'
                    series[1].color = '#008AD7'
                } else if(column.length === 1 && line.length === 1){
                    for(let serie in series){
                    series[serie].color = series[serie].sensor === 7 ? '#95A1EC' : '#008AD7'
                    }
                }
                } else if(series.length === 1){
                if(column.length === 1) {
                    series[0].color = '#95A1EC'
                } else {series[0].color = '#008AD7'} //type === line
                }
            }
            //colors
            this.series = series
            this.loading = false
        },
        async processChart(sensorId, reduced){
            sensorId = Number(sensorId)
            reduced = reduced.reverse()
            if (this.searchResult.type === 'mensal') {
                for (let item in reduced) {
                reduced[item].data = (reduced[item].ano + '-' + reduced[item].mes)
                }
            }
            if (this.searchResult.type === 'observado'){
                for(let observed in reduced) {
                reduced[observed].valor = reduced[observed].leitura
                }
            }
            let interval = this.makeIntervalDates(this.searchResult.type,this.searchResult.date_start,this.searchResult.date_end)
            reduced = this.checkHoles(this.searchResult.type,reduced,interval)
            let holder
            let values = []
            let y, x
            for (let index in reduced) {
              const fixedvalue = this.mapDecimalPlacesBySensorId(sensorId);
              let arrayItem = []
              if(reduced[index]){
              x = this.dateToUTC(reduced[index].data)
              if(sensorId === 8 || sensorId === 9){
                  y = reduced[index].valor * 3.6
              } else { y = reduced[index].valor }
              //y = reduced[index].valor
              arrayItem.push(x)
              arrayItem.push(y)
              values.push(arrayItem)
              }
              holder = {
              name: sensorId,
              data: [...values],
              type: sensorId === 7 ? 'column' : 'line',
              yAxis: sensorId === 7 ? 0 : 1,
              sensor: sensorId,
              tooltip: {
                  valueSuffix: this.mapUnitBySensorId(sensorId),
                  valueDecimals: fixedvalue ? fixedvalue : undefined
              }
              }
            }
            let sensorFind = this.sensors.find((a) => a.codigo === sensorId)
            holder.name = sensorFind.descricao;
            let text = this.searchResult.sensors.find((a) => a.codigo === sensorId)
            let title = { enabled: true, text: this.type !== "observado" ? text.descricao : text.name, style:{ color: '#FFFFFF' } }
            holder.title = title
            return holder
        },
        processResultForTable(searchResult){
          const { type, resultList, date_start, date_end, sensors } = searchResult;

          const datesInterval = this.makeIntervalDates(type, date_start, date_end);
          const resultListCopy = Object.assign([], resultList);
          const checkedHoles = [];
          for (const sensor of sensors) {
            const resultBySensor = resultListCopy.filter(result => result.sensorId == sensor.codigo)
            checkedHoles.push(...this.checkHolesTable(type, resultBySensor, datesInterval));
          }
          return { ...searchResult, resultList: checkedHoles };
        },

        makeIntervalDates(type,min,max){
          let interval = []
          let stringFormat = type === "mensal" ? "YYYY-MM" : type === "diario" ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm:ss+0000";
          min = moment(min).tz("America/Sao_Paulo").utc().format(stringFormat);
          max = moment(max).tz("America/Sao_Paulo").utc().format(stringFormat);
          if(type === 'diario'){
            let diff = moment(max, stringFormat).diff(moment(min, stringFormat), 'days')
            for (let i = 0; i <= diff; i++) {
              let number = parseInt(i)
              let val = moment(min, stringFormat).locale('pt-br').add(number, 'days').format(stringFormat)
              interval.push(val)
            }
          }
          else if(type === 'mensal'){
            let diff = moment(max, stringFormat).locale('pt-br').diff(moment(min, stringFormat), 'months')
            for (let i = 0; i <= diff; i++) {
              let number = parseInt(i)
              let val = moment(min, stringFormat).locale('pt-br').add(number, 'months').format(stringFormat)
              interval.push(val)
            }
          }
          else if(type === 'horario'){
            let diff = moment(max, stringFormat).diff(moment(min, stringFormat), 'hours');
            for (let i = 0; i <= diff; i++) {
              let number = parseInt(i)
              let val = moment(min, stringFormat).locale('pt-br').add(number, 'hours').format(stringFormat)
              interval.push(val)
            }
          }
          else if(type === 'observado'){
            let diff = moment(max, stringFormat).diff(moment(min, stringFormat), 'minutes')
            diff = diff /15
            for (let i = 0; i <= diff; i++) {
              let number = parseInt(i)
              let val = moment(min, stringFormat).locale('pt-br').add((15 * number), 'minutes').format(stringFormat)
              interval.push(val)
            }
          }
          return [...interval]
        },

        checkHolesTable(type,copy, datesInterval){
          const dates = datesInterval.reverse();
          let aux = []
          const pattern = copy[0]
          for(let index in dates){
            if(type === 'diario'){
              const item = copy.find((a) => moment(a.data).utc().isSame(moment(dates[index]).utc(), "days"))
              if(item){
                const fixedValue = this.mapDecimalPlacesBySensorId(item.sensorId);
                aux.push({...item, valor: fixedValue ? Number(item.valor).toFixed(fixedValue) : Number(item.valor)})
              } else {
                let holder = {
                  ...pattern,
                }
                holder.valor = null
                holder.data = dates[index]
                aux.push(holder)
              }
            }
            else if(type === 'mensal'){
              const item = copy.find((a) => moment(dates[index], 'YYYY-MM').utc().isSame(moment(`${a.ano}-${a.mes}`).utc(), "months"))
              if(item){
                const fixedValue = this.mapDecimalPlacesBySensorId(item.sensorId);
                aux.push({...item, valor: fixedValue ? Number(item.valor).toFixed(fixedValue) : Number(item.valor)})
              } else {
                  let holder = {
                    ...pattern,
                  }
                  holder.valor = null
                  holder.mes = Number(moment(dates[index], "YYYY-MM").format("MM"));
                  holder.ano = Number(moment(dates[index], "YYYY-MM").format("YYYY"))
                  aux.push(holder)
              }
            }
            else if(type === 'horario'){
              const item = copy.find((a) => moment(a.datahora).utc().isSame(moment(dates[index]).utc(), "hours"));
              if(item){
                const fixedValue = this.mapDecimalPlacesBySensorId(item.sensorId);
                aux.push({...item, valor: fixedValue ? Number(item.valor).toFixed(fixedValue) : Number(item.valor)})
              } else {
                let holder = {
                  ...pattern,
                }
                holder.valor = null
                holder.datahora = dates[index]
                aux.push(holder)
              }
            }
            else if(type === 'observado'){
              const item = copy.find((a) =>  moment(a.datahora).utc().isSame(moment(dates[index]).utc(), "minutes"));
              if(item){
               const fixedValue = this.mapDecimalPlacesBySensorId(item.sensorId);
                aux.push({...item, leitura: fixedValue ? Number(item.leitura).toFixed(fixedValue) : Number(item.leitura)})
              } else {
                let holder = {
                  ...pattern,
                }
                holder.leitura = null
                holder.datahora = dates[index]
                aux.push(holder)
              }
            }
          }
          return [...aux]
        },

        checkHoles(type,copy, dates){
            let aux = []
            const pattern = copy[0]
            for(let index in dates){
                if(type === 'diario'){
                let item = ''
                item = copy.find((a) => a.data === dates[index])
                if(item){
                    aux.push(item)
                } else {
                    let holder = {
                    ...pattern,
                    }
                    holder.valor = null
                    holder.data = dates[index]
                    aux.push(holder)
                }
                }
                else if(type === 'mensal'){
                let item = ''
                item = copy.find((a) => moment(dates[index], 'YYYY-MM').isSame(a.data, "months"))
                if(item){
                    aux.push(item)
                } else {
                    let holder = {
                    ...pattern,
                    }
                    holder.valor = null
                    holder.data = dates[index]
                    aux.push(holder)
                }
                }
                else if(type === 'horario' || type === 'observado'){
                  const item = copy.find((a) => moment(a.datahora).utc().isSame(moment(dates[index]).utc(), "hours"));
                  if(item){
                      item.data = item.datahora
                      aux.push(item)
                  } else {
                      let holder = {
                      ...pattern,
                      }
                      holder.valor = null
                      holder.data = dates[index]
                      aux.push(holder)
                  }
                }
            }
            return [...aux]
        },
        dateToUTC(x){
            let utc
            let type = this.searchResult.type
            let stringFormat = type === "mensal" ? "YYYY-MM" : type === "diario" ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm:ss+0000";
            if(type === 'diario'){
                utc = moment(x, stringFormat).locale('en').format(stringFormat)
                x = moment.utc(utc).locale('en').valueOf()
            }
            else if(type === 'mensal'){
                utc = moment(x, stringFormat).locale('en').format(stringFormat)
                x = moment.utc(utc).locale('en').valueOf()
            }
            else if(type === 'horario' || type === 'observado'){
                const localDate = moment(x).tz("America/Sao_Paulo").format('YYYY-MM-DD HH:mm')
                x = moment.utc(localDate).locale('en').valueOf()
            }
            return x
        },
        mapUnitBySensorId(codigo){
            if (codigo === 7) {
                return " mm"
            } else if (codigo === 10) {
                return " °"
            } else if (codigo === 15) {
                return " hPa"
            } else if (codigo === 3) {
                return " °C"
            } else if (codigo === 4) {
                return " °C"
            } else if (codigo === 1) {
                return " °C"
            } else if (codigo === 5) {
                return " °C"
            } else if (codigo === 2 || codigo === 187 || codigo === 188) {
                return " %"
            } else if (codigo === 9) {
                return " km/h"
            } else if (codigo === 6) {
                return " W/m²"
            } else if (codigo === 8) {
                return " km/h"
            } else if (codigo === 18) {
                return " m"
            } else if (codigo === 33) {
                return " m³/s"
            } else if (codigo === 20) {
                return " °C"
            } else if (codigo === 21) {
                return " mg/L"
            } else if (codigo === 177) {
                return " %"
            } else if (codigo === 294) {
                return "hm³"
            } else {
                return ""
            }
        },
        mapDecimalPlacesBySensorId(codigo){
            if (codigo === 7) {
                return 1
            } else if (codigo === 15) {
                return 1
            } else if (codigo === "pressAtmReduzida") {
                return 1
            } else if (codigo === 4) {
                return 1
            } else if (codigo === 3) {
                return 1
            } else if (codigo === 28 || codigo === 101) {
                return 1
            } else if (codigo === 1) {
                return 1
            } else if (codigo === 5) {
                return 1
            } else if (codigo === 2) {
                return 0
            } else if (codigo === 8) {
                return 1
            } else if (codigo === 9) {
                return 1
            } else if (codigo === 6) {
                return 0
            } else if (codigo === 18) {
                return 3
            } else if (codigo === 33) {
                return 2
            } else if (codigo === 20) {
                return 2
            } else if (codigo === 21 ||codigo === 180 ||codigo === 181) {
                return 3
            } else if (codigo === 177) {
                return 2
            } else if (codigo === 294) {
                return 3
            } else if (codigo === 187 || codigo === 188) {
                return 3;
            }
            else {
                return 0;
            }
        },

        changeTabItem(tabIndex){
            this.tab = tabIndex;
        },
        chartRenderComplete(chart){
            this.chartRendered = chart;
        },

        exportChart(typeFile){
            this.chartRendered.exportChart({type: typeFile});
        },

        exportPDF(){
            if(this.isTableTab){
                this.$refs.settingsExportDialog.openSettingsDialog("pdf");
            }
        },

        exportCSV(){
            if(this.isTableTab){
                this.$refs.settingsExportDialog.openSettingsDialog("csv");
            }else{
                 this.chartRendered.downloadCSV();
            }
        },

        exportXLS(){
            if(this.isTableTab){
                this.$refs.settingsExportDialog.openSettingsDialog("xls");
            }else{
                this.chartRendered.downloadXLS()
            }
        },

        fullscreenChart(){
            const fullscreenControl = new Highcharts.Fullscreen(this.chartRendered);
            fullscreenControl.open();
        },
        printChart(){
            this.chartRendered.print();
        },

        exportDataTable(settings){
            const { fileType } = settings;
            const typeTable = this.getType;
            const isDailyMonthlyTable = typeTable === "diario" || typeTable === "mensal";
            const isHourlyTable = typeTable === "horario";
            const isObservedTable = typeTable === "observado";
            if(fileType === "pdf"){
                if(isDailyMonthlyTable){
                    this.$refs[this.dailyMonthlyTableDataRef].generatePDF(settings);
                }
                if(isHourlyTable){
                    this.$refs[this.hourlyTableDataRef].generatePDF(settings);
                }
                if(isObservedTable){
                    this.$refs[this.observedTableDataRef].generatePDF(settings);
                }
            }
            if(fileType === "csv"){
                if(isDailyMonthlyTable){
                    this.$refs[this.dailyMonthlyTableDataRef].generateCSV(settings);
                }
                if(isHourlyTable){
                    this.$refs[this.hourlyTableDataRef].generateCSV(settings);
                }
                if(isObservedTable){
                    this.$refs[this.observedTableDataRef].generateCSV(settings);
                }
            }
            if(fileType === "xls"){
                if(isDailyMonthlyTable){
                    this.$refs[this.dailyMonthlyTableDataRef].generateXLS(settings);
                }
                if(isHourlyTable){
                    this.$refs[this.hourlyTableDataRef].generateXLS(settings);
                }
                if(isObservedTable){
                    this.$refs[this.observedTableDataRef].generateXLS(settings);
                }
            }
        },

        applyPeriod(periodSelected){
            this.otherPeriodSelected = periodSelected;
            this.$emit("applyPeriod", periodSelected);
        },

        loadAnimationComplete(){
            this.showAnimation = this.loadingOtherPeriod || this.loadingData;
        },

        formatDate(date){
            const { type } = this.searchResult;
            const stringFormat = type === "mensal" ? "MMMM/YYYY" : type === "diario" ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm";
            const dateFormatted = moment(date).tz("America/Sao_Paulo").locale("pt-br").format(stringFormat);
            return type === "mensal" ? this.capitalize(dateFormatted) : dateFormatted;
        },

        capitalize(text){
            return text[0].toUpperCase() + text.slice(1);
        }
    }
}
</script>

<style scoped>
   .tab-item-title{
        color: var(--v-secondary-lighten1) !important;
        border: 1px solid var(--v-secondary-lighten1);
        text-transform: none;
    }
    #tab-charts{
        border-radius: 4px 0px 0px 4px;
    }
    /* #tab-rain-level{

    } */
    #tab-table{
        border-radius: 0px 4px 4px 0px
    }
</style>
